// extracted by mini-css-extract-plugin
export default {"checkboxInput":"DocumentationSelection_checkboxInput__TbAFv","floor":"DocumentationSelection_floor__vUT-I"};